/**
 * Top-level view state (Signa 2.0). The handoff collapses the earlier
 * PA Chat / Today split into a single unified Today view and promotes
 * Todos / Notes / Memory to first-class sections in the left sidebar.
 */

export type SignaView = 'today' | 'inbox' | 'archive' | 'todos' | 'notes' | 'memory';

export const VIEWS: { id: SignaView; label: string; shortcut: string }[] = [
  { id: 'today', label: 'Today', shortcut: 'Cmd/Ctrl+1' },
  { id: 'inbox', label: 'Inbox', shortcut: 'Cmd/Ctrl+2' },
  { id: 'archive', label: 'Archive', shortcut: 'Cmd/Ctrl+3' },
  { id: 'todos', label: 'Todos', shortcut: 'Cmd/Ctrl+4' },
  { id: 'notes', label: 'Notes', shortcut: 'Cmd/Ctrl+5' },
  { id: 'memory', label: 'Memory', shortcut: 'Cmd/Ctrl+6' },
];

export const VIEW_STORAGE_KEY = 'signa-view';
export const DEFAULT_VIEW: SignaView = 'today';

const VIEW_IDS: SignaView[] = ['today', 'inbox', 'archive', 'todos', 'notes', 'memory'];

export function isView(v: unknown): v is SignaView {
  if (typeof v !== 'string') return false;
  return (VIEW_IDS as string[]).includes(v);
}

export function readStoredView(): SignaView {
  if (typeof localStorage === 'undefined') return DEFAULT_VIEW;
  const raw = localStorage.getItem(VIEW_STORAGE_KEY);
  if (isView(raw)) return raw;
  // Migrate legacy 'chat' to 'today' (chat was merged into today in 2.0).
  if (raw === 'chat') {
    localStorage.setItem(VIEW_STORAGE_KEY, 'today');
    return 'today';
  }
  return DEFAULT_VIEW;
}

export function writeStoredView(view: SignaView): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(VIEW_STORAGE_KEY, view);
}
